import { useState, useCallback } from 'react';
import FreeComicPopup from './FreeComicPopup';

export default function HeroSection() {
  const [showPopup, setShowPopup] = useState(false);

  const handleOpenPopup = useCallback(() => {
    setShowPopup(true);
  }, []);

  const handleClosePopup = useCallback(() => {
    setShowPopup(false);
  }, []);

  return (
    <>
      <section className="relative w-full h-[580px] md:h-[680px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20artistic%20illustration%20of%20Korean%20manhwa%20webtoon%20panels%20floating%20in%20a%20cosmic%20space%20with%20warm%20golden%20and%20coral%20gradients%2C%20abstract%20geometric%20shapes%2C%20soft%20glowing%20particles%2C%20modern%20digital%20art%20style%2C%20ethereal%20atmosphere%2C%20cinematic%20composition%20with%20ample%20negative%20space%20for%20text%20overlay&width=1600&height=800&seq=hero-bg-manhwa&orientation=landscape"
          alt="韩漫漫画 - 海量正版韩漫在线阅读平台"
          title="韩漫漫画网站 - 免费漫画在线阅读平台"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/50 via-foreground-950/30 to-foreground-950/60" />

        <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-8">
          <div className="w-full max-w-[900px] text-center">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/20 text-accent-300 text-sm font-medium mb-6 border border-accent-500/30">
              <i className="ri-sparkling-line mr-1.5"></i>
              每日更新 · 海量正版韩漫
            </span>

            <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading text-background-50 leading-tight mb-6">
              探索无尽
              <span className="text-accent-400">漫画世界</span>
            </h1>

            <p className="text-lg md:text-xl text-background-200/80 max-w-[650px] mx-auto mb-10 leading-relaxed">
              海量正版韩漫漫画在线阅读平台，恋爱、奇幻、动作、悬疑等多元分类，资源合法安全，访问便捷，畅享高品质阅读体验。
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <button
                type="button"
                onClick={handleOpenPopup}
                className="group relative px-8 py-3.5 rounded-full bg-accent-500 text-foreground-950 text-base font-bold overflow-hidden transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <span className="relative z-10 flex items-center gap-2">
                  <i className="ri-fire-line text-xl"></i>
                  免费漫画弹窗入口
                </span>
                <div className="absolute inset-0 bg-accent-400 scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />
              </button>

              <a
                href="/category/all"
                className="px-8 py-3.5 rounded-full border-2 border-background-50/40 text-background-50 text-base font-medium hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap"
              >
                <i className="ri-compass-3-line mr-1.5"></i>
                浏览全部漫画
              </a>
            </div>

            <div className="flex items-center justify-center gap-8 mt-12">
              {[
                { value: '10,000+', label: '正版漫画' },
                { value: '500万+', label: '活跃读者' },
                { value: '99.9%', label: '好评率' },
                { value: '每日更新', label: '更新频率' },
              ].map(stat => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-background-300 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
          <div className="w-6 h-10 rounded-full border-2 border-background-50/40 flex items-start justify-center pt-2">
            <div className="w-1 h-2.5 rounded-full bg-background-50/60 animate-bounce" />
          </div>
        </div>
      </section>

      {showPopup && <FreeComicPopup onClose={handleClosePopup} />}
    </>
  );
}